// export default BackToTop;
import React, { useState, useEffect } from "react";
import { animateScroll } from "react-scroll";
import { IconArrowRight } from "../../components/Icons";

const BackToTop = ({ offset = 1000 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > offset) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    // Check initial position on mount
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [offset]);

  return (
    <>
      {show && (
        <button
          className="back-to-top"
          type="button"
          aria-label="Back to top"
          onClick={() => animateScroll.scrollToTop()}
        >
          <IconArrowRight width="18" height="18" style={{ transform: "rotate(-90deg)" }} />
        </button>
      )}
    </>
  );
};

export default BackToTop;

